import { SagaIterator } from 'redux-saga';
import { ClientError } from '../../models/common';
import { tryCall } from '../effects/try-call';

export const createTryCallSaga = <T>(saga: () => SagaIterator<T>): (() => SagaIterator<T | ClientError>) =>
    function* () {
        return yield tryCall(saga);
    };
